import React from 'react';
import { isMobile } from 'react-device-detect';
import { Container, styled } from '@mui/material';
import { useLocation } from 'react-router-dom';

const MainContainer = styled(Container, {
  shouldForwardProp: prop => prop !== 'isInAccount',
})<{ isInAccount: boolean }>(({ isInAccount }) => ({
  flexGrow: 1,
  padding: `${isInAccount ? '0' : '16px'} ${isInAccount ? '0 !important' : isMobile ? '12px' : '16px'}`,
  maxWidth: isInAccount ? 'unset !important' : 'inherit',
}));

export const Main = ({ children }: any) => {
  const { pathname } = useLocation();
  const isInAccount = pathname.includes('account');

  return <MainContainer isInAccount={isInAccount}>{children}</MainContainer>;
};
